import React from 'react';
import PropTypes from 'prop-types';
import {Table} from "reactstrap";
import minutesToHours from "../../../../utils/minutesToHours";
import RawToolsIcon from "./RawToolsIcon";
import {workStepName} from "../Times";
import {useTranslation} from "react-i18next";

const WorkPositions = props => {
  const { t } = useTranslation('tec_rmi');

  return <Table className="table-bordered">
    <thead>
    <tr>
      <th>{t('scope_of_work')}</th>
      <th>{t('time')}</th>
    </tr>
    </thead>
    <tbody>
    {props.workPositions.map((workPosition, k) => <tr key={k.toString()}>
      <td>
        <div className="d-flex justify-content-between align-items-center">
          <span>{workStepName(workPosition)}</span>
          <RawToolsIcon workPosition={workPosition} />
        </div>
      </td>
      <td className="text-right">{minutesToHours(workPosition.WorkTime, false, 2)}</td>
    </tr>)}
    </tbody>
    <tfoot>
    <tr className="font-weight-bold bg-light">
      <td className="text-right">{t('total')}</td>
      <td className="text-right">{minutesToHours(props.workPositions.map(workPosition => workPosition.WorkTime).reduce((acc, time) => acc + time, 0), false, 2)}</td>
    </tr>
    </tfoot>
  </Table>;
};

WorkPositions.propTypes = {
  workPositions: PropTypes.arrayOf(PropTypes.shape({

  }),).isRequired,
};

export default WorkPositions;